import React, { Component } from 'react';
import ccxt from '@jmpdev/ccxt';
import { ThemeProvider } from 'styled-components';
import _ from 'lodash';
import { Category, ThemeBar } from '../components';
import { FavExchanges, FavMarkets, Favorites } from './';
import { Theme } from '../constants';
import mendExchanges from '../data/mendExchanges.json';

class App extends Component {
  state = {
    theme: 'dracula',
    pairs: [],
    watchList: [],
    exchange: '',
    exchanges: {},
    markets: {},
  };

  componentDidMount() {
    const theme = localStorage.getItem('cmTheme') || this.state.theme;
    const exchanges = this.getExchanges();
    this.setState({ theme, exchanges });
  }

  getExchanges = () => _.keyBy(mendExchanges.map(id => new ccxt[id]({ enableRateLimit: true })), 'id');

  selectTheme = (event) => {
    const theme = event.target.value;
    this.setState({ theme });
    localStorage.setItem('cmTheme', theme);
  };

  selectExchange = async (event) => {
    const exchange = this.state.exchanges[event.target.id];
    exchange.proxy = 'https://cors-anywhere.herokuapp.com/';
    const marketList = await exchange.loadMarkets();
    const markets = _.orderBy(marketList, 'symbol');
    this.setState({ markets, exchange });
  };

  selectMarket = (event) => {
    const { exchange, watchList } = this.state;
    const watch = { exchange: exchange.id, market: event.target.id };
    const hasWatch = _.some(watchList, watch);
    const list = hasWatch ? _.reject(watchList, item => _.isEqual(item, watch)) : _.concat(watchList, [watch]);
    this.setState({ watchList: list }, this.loadCoins);
  };

  makePair = async ({ exchange, market }) =>
    new Promise(async (resolve, reject) => {
      try {
        const currExchange = this.state.exchanges[exchange];
        const ticker = await currExchange.fetchTicker(market);
        const info = currExchange.markets[market];
        const id = `${exchange}-${market}`;
        const pair = { id, exchange: { id: exchange, name: currExchange.name }, ticker, info };
        resolve(pair);
      } catch (error) {
        reject(error);
      }
    });

  loadCoins = async () => {
    const { watchList } = this.state;
    const watching = watchList.map(watch => this.makePair(watch));
    const pairs = await Promise.all(watching);
    this.setState({ pairs });
  };

  render() {
    const { theme, pairs, markets, watchList, exchange, exchanges } = this.state;
    const activeTheme = Theme[theme];
    return (
      <ThemeProvider theme={activeTheme}>
        <div>
          <ThemeBar selectTheme={this.selectTheme} selectedTheme={theme} />
          <Category title="Favorites">
            <FavExchanges exchanges={exchanges} selectExchange={this.selectExchange} />
            <FavMarkets watchList={watchList} exchange={exchange} markets={markets} selectMarket={this.selectMarket} />
            <Favorites pairs={pairs} />
          </Category>
          <ThemeBar selectTheme={this.selectTheme} selectedTheme={theme} />
        </div>
      </ThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js